<template>
<!-- BEGIN: Top Bar -->
<div class="top-bar">
    <!-- BEGIN: Hamburger Menu (Mobile Only) -->
    <button 
      @click="toggleMobileMenu" 
      class="hamburger-menu-btn md:hidden mr-4"
      aria-label="Toggle menu"
    >
      <fa-icon :icon="['fas', 'bars']" />
    </button>
    <!-- END: Hamburger Menu -->
    <!-- BEGIN: Breadcrumb -->
    <Breadcrumb />
    <!-- END: Breadcrumb -->
    <!-- BEGIN: Search -->
    <div class="intro-x relative mr-4 sm:mr-6">
        <a class="notification sm:hidden" href="#"> <i data-feather="search" class="notification__icon"></i> </a>
    </div>
    <!-- END: Search -->
        <!-- BEGIN: User ID -->
    <div class="intro-x mr-auto hidden sm:block sm:mr-6">
        <div class=""> 
          {{ userFullName }} | {{ user.role | capitalizeAndReplace }}<br /> 
          <!-- <small>{{ user.role | capitalizeAndReplace }} ID: {{ user.id }} </small> -->
        </div>
    </div>
    <!-- END:  User ID -->
    <!-- BEGIN: Notifications -->
    <div class="intro-x mr-6 hidden sm:block">
        <NotificationBell />
    </div>
    <!-- END: Notifications -->
        <!-- BEGIN: User ID -->
    <div class="intro-x  ml-auto block sm:hidden">
        <div class=""> 
          {{ userFullName }} | {{ user.role | capitalizeAndReplace }}<br /> 
          <small>{{ user.role | capitalizeAndReplace }} ID: {{ user.id }}</small>
        </div>
    </div>
    <!-- END:  User ID -->
 <!-- BEGIN: Account Menu -->
    <div class="intro-x dropdown w-8 h-8 relative ml-4">
        <div class="dropdown-toggle w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in">
          <img alt="" :src="user.profile_image || '/assets/images/profile-7.jpg'">
        </div>
        <div class="dropdown-box mt-10 absolute w-56 top-0 right-0 z-20 shadow-xl ">
            <div class="dropdown-box__content box" >
              <div class="p-4 border-b dark:border-gray-700">
                  <div class="font-medium">{{ userFullName }}</div>
                  <div class="text-xs text-gray-500">{{ user.role | capitalizeAndReplace }}</div>
              </div>
              <div class="p-2">
                  <router-link :to="{name: 'profile'}" class="dropdown-toggle flex items-center block p-2 transition duration-300 ease-in-out hover:bg-gray-500 rounded-md"> 
                      <i data-feather="user" class="w-4 h-4 mr-2 "></i> Profile
                  </router-link>
              </div>
              <!-- BEGIN: Dark Mode Switcher-->
              <div class="dark-mode-switcher p-2 border-t dark:border-gray-700">
                <div class="input--switch flex items-center p-2 w-full hover:bg-gray-500 text-gray-700 dark:text-gray-300 rounded-md transition duration-300 ease-in-out "><i data-feather="moon" class="w-4 h-4 mr-2"></i>Dark Mode
                  <input class="m-1 ml-auto input input--switch border" @click="darkModeEvent" type="checkbox" value="1">
                </div>
              </div>
              <div class="p-2 border-t dark:border-gray-700">
                  <a href="#" @click.prevent="logout()" class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-gray-500 rounded-md"> 
                      <i data-feather="toggle-right" class="w-4 h-4 mr-2"></i> Logout 
                  </a>
              </div>
            </div>
        </div>
    </div>
    <!-- END: Account Menu -->
</div>
<!-- END: Top Bar -->
</template>
<script>
import Breadcrumb from "@/components/core/Breadcrumb"
import NotificationBell from "@/components/core/NotificationBell"

export default {
  data: function() {
    return{
      messages: []
    }
  },
  props: {
    user: {
      type: Object,
    },
  },
  components: {
    Breadcrumb,
    NotificationBell
  },
  mounted() {
    this.initDarkMode();
  },
  methods: {
    toggleMobileMenu() {
      this.$root.$emit('toggle-mobile-menu');
    },
    logout() {
      if (event) event.preventDefault()
      this.$store.dispatch('AUTH_LOGOUT').then(() => {
        this.$router.push('/login')
      })
    },
    darkModeEvent() {
      "use strict";
      
      // Toggle dark mode
      const htmlElement = document.documentElement;
      const isDarkMode = htmlElement.classList.contains('dark');
      
      if (isDarkMode) {
        htmlElement.classList.remove('dark');
        localStorage.removeItem('dark-mode');
        $('.dark-mode-switcher').find('input').prop('checked', false);
      } else {
        htmlElement.classList.add('dark');
        localStorage.setItem('dark-mode', 'true');
        $('.dark-mode-switcher').find('input').prop('checked', true);
      }
    },
    
    initDarkMode() {
      // Initialize dark mode on page load
      const isDarkModeEnabled = localStorage.getItem('dark-mode') === 'true';
      
      if (isDarkModeEnabled) {
        document.documentElement.classList.add('dark');
        $('.dark-mode-switcher').find('input').prop('checked', true);
      } else {
        document.documentElement.classList.remove('dark');
        $('.dark-mode-switcher').find('input').prop('checked', false);
      }
    }    
  }, 
  computed: {
    userFullName() {
      return this.user.first_name + " " + this.user.last_name
    },
    verifiedUser() {
      if(this.user.is_verified) {
        return 'Verified'
      } else {
        return 'Not Verified'
      }
    },
  }
}
</script>

<style scoped>
.hamburger-menu-btn {
  background: #1e40af;
  border: none;
  color: #ffffff;
  padding: 10px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 18px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.hamburger-menu-btn:hover {
  background: #1e3a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}

.hamburger-menu-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>

<style>
/* Dark mode for hamburger button - non-scoped */
html.dark .hamburger-menu-btn {
  background: #3b82f6 !important;
  color: #ffffff !important;
}

html.dark .hamburger-menu-btn:hover {
  background: #2563eb !important;
}
</style>